<template>
  <div class="modal fade" id="updateBookingModal" tabindex="-1" role="dialog" aria-labelledby="bookingModalTitle"
    aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
      <div class="modal-content">

        <div class="modal-header">
          <h5 class="modal-title">
            Update Booking Details:
            <strong>{{ bookingDetails.crew }}</strong>
          </h5>

          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>

        <div class="modal-body py-5">

          <div class="form-row">

            <div class="col-md-6 mb-3">
              <label class="float-left">
                Booked Check-In
              </label>

              <input type="date" class="form-control form-control-sm"
                v-model="bookingDetails.booking.booked_checked_in">
            </div>

            <div class="col-md-6 mb-3">
              <label class="float-left">
                Booked Check-Out
              </label>

              <input type="date" class="form-control form-control-sm"
                v-model="bookingDetails.booking.booked_checked_out">
            </div>

          </div>

          <div class="form-row">

            <div class="col-md-6 mb-3">
              <label class="float-left">
                Hotel
              </label>

              <select class="form-control" v-model="bookingDetails.booking.hotel_id">
                <option v-for="hotel in hotels" :key="hotel.id" :value="hotel.id" v-if="hotel.status == 1">
                  {{ hotel.name.toUpperCase() }}
                </option>
              </select>
            </div>

            <div class="col-md-6 mb-3">
              <label class="float-left">
                Floor (Current Floor: {{ bookingDetails.booking.floor ? bookingDetails.booking.floor :
                  'No Floor Selected' }})
              </label>
              <select class="form-control" v-model="bookingDetails.booking.floor_id">
                <option v-for="floor in floors" :key="floor.id" :value="floor.id" v-if="floor.status == 1">
                  {{ floor.code.toUpperCase() }}
                </option>
              </select>
            </div>

            <div class="col-md-6 mb-3" v-if="roomsAvailable && roomsAvailable.length">
              <label class="float-left">
                Bed (Current Bed: {{ bookingDetails.booking.bed ? bookingDetails.booking.bed :
                  'No Bed Selected' }})
              </label>

              <select class="form-control" v-model="bookingDetails.booking.bed_id">
                <option v-for="room in roomsAvailable" :key="room.bed_id" :value="room.bed_id">
                  🛏 {{ room.name.toUpperCase() }}
                  │
                  🏷 {{ room.code.toUpperCase() }}
                </option>
              </select>
            </div>

          </div>

          <div class="form-row">
            <div class="col text-right">
              <button type="button" class="btn btn-sm btn-secondary" @click="updateCrewDetails">
                Update
              </button>
            </div>
          </div>

        </div>

      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'UpdateBookingDetailModal',
  data() {
    return {
      bookingDetails: {
        booking: {}
      },
      initializing: false
    }
  },

  computed: {
    ...mapGetters([
      'hotels',
      'floors',
      'roomsAvailable'
    ])
  },

  watch: {
    'bookingDetails.booking.hotel_id'(newValue) {
      this.getFloorsByHotel({
        hotel_id: this.bookingDetails.booking.hotel_id
      })
    },

    'bookingDetails.booking.floor_id'(newValue) {
      this.bedsPerRoom({
        dateFrom: this.bookingDetails.booking.booked_checked_in,
        dateTo: this.bookingDetails.booking.booked_checked_out,
        hotel_id: this.bookingDetails.booking.hotel_id,
        floor_id: newValue
      })
    }
  },

  methods: {
    ...mapActions([
      'getHotels',
      'getFloorsByHotel',
      'bedsPerRoom'
    ]),

    open(crew) {
      this.bookingDetails = {
        booking: {}
      }
      this.initializing = true
      this.bookingDetails = JSON.parse(JSON.stringify(crew))
      this.$nextTick(() => {
        this.initializing = false
        $('#updateBookingModal').modal('show')
      })
      this.getFloorsByHotel({
        hotel_id: this.bookingDetails.booking.hotel_id
      })
      this.bedsPerRoom({
        dateFrom: this.bookingDetails.booking.booked_checked_in,
        dateTo: this.bookingDetails.booking.booked_checked_out,
        hotel_id: this.bookingDetails.booking.hotel_id,
        floor_id: this.bookingDetails.booking.floor_id
      })
    },

    updateCrewDetails() {
      const {
        id,
        bed_id,
        floor_id,
        hotel_id,
        booked_checked_in,
        booked_checked_out
      } = this.bookingDetails.booking

      this.$emit('updateDetails', {
        id,
        bed_id,
        floor_id,
        hotel_id,
        booked_check_in: booked_checked_in,
        booked_check_out: booked_checked_out
      })

      $('#updateBookingModal').modal('hide')
    }
  },

  created() {
    this.getHotels()
  }
}
</script>

<style scoped>
.modal-body label {
  font-weight: 600;
}

.modal-body select,
.modal-body input {
  min-height: 38px;
}
</style>
